import { useState, useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import axios from "axios"
import { toast } from "react-toastify"
import { generatePDF } from "../components/generateOrderCyclePDF"

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL

const CustomerOrderRequest = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const [orderCycle, setOrderCycle] = useState(null)
  const [products, setProducts] = useState([])
  const [selectedProducts, setSelectedProducts] = useState([])
  const [totalPrice, setTotalPrice] = useState(0)
  const [selectedLocation, setSelectedLocation] = useState("")
  const [locations, setLocations] = useState([])
  const [customerName, setCustomerName] = useState("")
  const [customerId, setCustomerId] = useState("")
  const [locationName, setLocationName] = useState("")
  const [locationId, setLocationId] = useState("")
  const [orderSubmitted, setOrderSubmitted] = useState(false)
  const [organization, setOrganization] = useState("")
  const [searchTerm, setSearchTerm] = useState("")
  const [description, setDescription] = useState("") // Add description state

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search)
    const orderCycleCode = queryParams.get("orderCycleCode")
    const customerName = queryParams.get("customerName")
    const customerId = queryParams.get("customerId")

    console.log("Order Cycle Code:", orderCycleCode)
    console.log("Customer Name:", customerName)

    setCustomerName(customerName || "Customer")
    setCustomerId(customerId || "")

    if (orderCycleCode) {
      console.log("Trigger function to fetch order cycle details")
      fetchOrderCycleDetails(orderCycleCode)
    } else {
      toast.error("Invalid order cycle request.")
    }
  }, [])

  const fetchOrderCycleDetails = async (orderCycleCode) => {
    console.log("orderCycleCode in the function: ", orderCycleCode)
    try {
      const response = await axios.get(
        `${API_BASE_URL}/orders/get-order-details-from-the-order-cycle/${orderCycleCode}`,
      )

      console.log("orderCycleCode data dfdg: ", response.data)
      console.log("orderCycleCode ID: ", response.data._id)

      if (response.data) {
        setOrderCycle(response.data) // Store entire order cycle
        if (response.data.status === "Active") {
          setProducts(response.data.products || []) // Store latest product list
        }
        setLocationName(response.data.location || "Location")
        setLocationId(response.data.locationId || "")
        setOrganization(response.data.organization || "Organization")
        // setStatus(response.data.status || "Status");
      } else {
        toast.error("Order cycle data is unavailable.")
      }
    } catch (error) {
      console.error("Error fetching order cycle details:", error)
      toast.error("Failed to fetch latest product details.")
    }
  }

  useEffect(() => {
    if (!organization || organization === "Organization") return

    console.log("dddd organization:", organization)

    const fetchLocations = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/locations/organization/${organization}`)

        console.log("location response:", response.data)

        const formattedLocations = response.data.locations.map((loc) => ({
          id: loc._id,
          location_name: loc.location_name,
          latitude: loc.latitude,
          longitude: loc.longitude,
        }))

        setLocations(formattedLocations)

        console.log("formattedLocations:", formattedLocations)
      } catch (error) {
        console.error("Error fetching locations:", error)
        toast.error("Failed to fetch locations.")
      }
    }
    fetchLocations()
  }, [organization])

  const filteredProducts = products.filter((product) =>
    product.product_name.toLowerCase().includes(searchTerm.toLowerCase()),
  )

  console.log("Location in organization:", organization)

  // Helper function to get price from orderCyclePrice
  const getPrice = (product) => {
    if (product.orderCyclePrice && product.orderCyclePrice.$numberDecimal) {
      return Number(product.orderCyclePrice.$numberDecimal)
    }
    return 0
  }

  const handleProductSelection = (product, isChecked) => {
    const price = getPrice(product)
    const updatedSelectedProducts = isChecked
      ? [...selectedProducts, { ...product, quantity: 0, total: 0, price }] // Store price for easier access
      : selectedProducts.filter((p) => p.product_code !== product.product_code)

    setSelectedProducts(updatedSelectedProducts)

    const updatedTotal = updatedSelectedProducts.reduce((acc, p) => acc + p.total, 0)
    setTotalPrice(updatedTotal)
  }

  const handleQuantityChange = (productCode, quantity) => {
    if (quantity < 0) return

    const updatedProducts = selectedProducts.map((product) =>
      product.product_code === productCode ? { ...product, quantity, total: product.price * quantity } : product,
    )

    setSelectedProducts(updatedProducts)

    const updatedTotal = updatedProducts.reduce((acc, p) => acc + p.total, 0)
    setTotalPrice(updatedTotal)
  }

  const handleConfirmOrder = async () => {
    if (selectedProducts.length === 0) {
      toast.warn("No products selected. Please select at least one product.");
      return;
    }

    if (!selectedLocation) {
      toast.error("Please select a location.");
      return;
    }

    if (!customerId) {
      toast.error("Customer name is required.");
      return;
    }

    try {
      if (!customerId) {
        toast.error("Customer not found. Check the customer name.");
        return;
      }

      for (const product of selectedProducts) {
        if (!product.partial_qty_allocation && !Number.isInteger(product.quantity)) {
          toast.error(`Quantity for ${product.product_name} must be a whole number.`);
          return; // Stop order submission if validation fails
        }
      }

      if (!locationId) {
        toast.error("Location not found. Please select a valid location.");
        return;
      }

      const pickupLocationId = selectedLocation?.id;

      const formattedProducts = selectedProducts.map((product) => ({
        product_id: product.product_code,
        quantity: product.quantity,
        unit_price: product.price,
        partial_qty_allocation: product.partial_qty_allocation,
        unit: product.unit,
      }));

      // Submit order request without auth headers
      const response = await axios.post(
        `${API_BASE_URL}/orders/order-cycle/submit-customer-order-request`,
        {
          customerId,
          locationId,
          orderCycle_id: orderCycle._id,
          pickupLocationId,
          products: formattedProducts,
          description: description,
        }
      );

      console.log("Payload being sent:", {
        customerId,
        locationId,
        products: formattedProducts,
        pickupLocationId,
        description,
      });

      if (response.data.success) {
        toast.success(
          `Order Request Confirmed! Order ID: ${
            response.data.order?.orderRequestCode || "N/A"
          }`
        );

        // Fetch customer info WITHOUT auth headers
        const customerResponse = await axios.get(
          `${API_BASE_URL}/customers/get-by-code/${customerId}`
        );

        console.log(customerResponse);

        const customer = customerResponse.data.customer;
        const customerWhatsApp = customer.cus_mobileno.startsWith("+94")
          ? customer.cus_mobileno
          : "+94" + customer.cus_mobileno.replace(/^0/, "");

          const fromLocation = locationName || "N/A";
          const pickupLocation = selectedLocation?.location_name || "N/A";


          if (customer.whatsapp_allowed === true) {
            await axios.post(`${API_BASE_URL}/sendwhatsapp/sendwhatsapp`, {
              messageType: "newOrderTemplate",
              phoneNumber: customerWhatsApp,
              customerName: customer.customer_name,
              orderRequestCode: response.data.order.orderRequestCode,
              description: description || "",
              messages: selectedProducts,
              customerCode: customer.customer_code, 
              fromLocation,
              pickupLocation,
            });
          }

          await axios.post(`${API_BASE_URL}/sendwhatsapp/sendwhatsapp`, {
            messageType: "OrderRequestSuccess",
            phoneNumber: customerWhatsApp,
            customerName: customer.customer_name,
            orderRequestCode: response.data.order.orderRequestCode,
            description: description || "",
            messages: selectedProducts,
            fromLocation,
            pickupLocation,
          });


        setOrderSubmitted(true);
        navigate("/order-receipt", {
          state: {
            order: {
              ...response.data.order,
              customer_name: customer.customer_name,
              location_name: selectedLocation.location_name,
              latitude: selectedLocation.latitude,
              longitude: selectedLocation.longitude,
              orderItems: selectedProducts.map((product) => ({
                product_code: product.product_code,
                product_image: product.product_image,
                product_name: product.product_name,
                quantity: product.quantity,
                unit_price: product.price,
                unit: product.unit,
                total_price: product.price * product.quantity,
                partial_qty_allocation: product.partial_qty_allocation,
              })),
            },
          },
        });
      } else {
        toast.error(response.data.message || "Failed to submit order.");
      }
    } catch (error) {
      console.error("Error submitting order request:", error);
      let errorMessage = "Failed to submit order request. Please try again.";

      if (error.response) {
        // Server responded with a status code other than 2xx
        errorMessage = error.response.data?.message || errorMessage;
      } else if (error.request) {
        // Request was made but no response received
        errorMessage = "No response from server. Please check your network.";
      } else {
        // Other errors
        errorMessage = error.message;
      }

      toast.error(errorMessage);
    }
  };

  if (!orderCycle) return <p className="text-center text-lg">Loading...</p>

  // Conditional Rendering based on the order cycle status
  if (orderCycle.status === "Inactive" || orderCycle.status === "Closed") {
    return <div className="text-center font-bold text-3xl sm:p-16">This order cycle is closed.</div>
  }

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center p-4 sm:p-6">
      <div className="bg-white shadow-md rounded-lg p-4 sm:p-6 w-full max-w-3xl">
        <div className="text-center mb-6">
          <img
            src="/agro_farm_ims_logo.png"
            alt="Agro Farm Logo"
            className="mx-auto w-20 h-20 sm:w-28 sm:h-28 object-contain"
          />
          <h1 className="text-lg sm:text-2xl font-bold">Agro Farm Products</h1>
        </div>
        <div className="flex items-center justify-between mb-4">
          <div>
            <p className="text-gray-900 text-sm sm:text-base mb-2">
              Customer Name: <span className="font-semibold">{customerName}</span>
            </p>
            <p className="text-gray-800 text-sm sm:text-base mb-2">Date - {new Date().toLocaleDateString()}</p>
            <p className="text-gray-900 text-sm sm:text-base mb-2">
              From Location: <span className="font-semibold">{locationName}</span>
            </p>
          </div>
          <div className="flex justify-center md:justify-start p-4">
            <button
              className="w-full md:w-auto bg-green-500 text-white px-6 py-3 md:px-4 md:py-2 rounded-md hover:bg-green-600 text-sm md:text-base"
              onClick={() => generatePDF(orderCycle)}
            >
              Download
            </button>
          </div>
        </div>
        <div className="mb-4">
          <input
            type="text"
            placeholder="Search Products by Name"
            className="w-full px-4 py-2 border border-gray-300 rounded-md"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        {/* Product List */}
        <h2 className="text-lg sm:text-xl font-semibold mt-4 mb-2">Product List</h2>
        <div className="space-y-4">
          {filteredProducts.map((product, index) => {
            const selectedProduct = selectedProducts.find((p) => p.product_code === product.product_code)
            const selectedQuantity = selectedProduct ? selectedProduct.quantity : 0
            const productTotal = selectedProduct ? selectedProduct.total : 0
            const price = getPrice(product)

            return (
              <div
                className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-2 sm:space-y-0 sm:space-x-4 bg-gray-50 border border-gray-300 rounded-lg p-4 shadow-sm"
                key={product.product_code}
              >
                <div className="flex items-center space-x-4">
                  <input
                    type="checkbox"
                    checked={!!selectedProduct}
                    onChange={(e) => handleProductSelection(product, e.target.checked)}
                    className="form-checkbox h-5 w-5 text-green-600"
                  />
                  <p className="text-gray-800 font-medium">{product.product_code || "N/A"}</p>
                  <img
                    src={`${process.env.REACT_APP_IMAGE_BASE_URL}${product.product_image}`}
                    alt={product.product_name || "Product Image"}
                    className="w-16 h-16 object-cover rounded-lg border border-gray-200"
                  />
                  <p className="text-gray-700">{product.product_name || "Unknown"}</p>
                </div>

                <div className="flex flex-row items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <button
                      onClick={() =>
                        handleQuantityChange(
                          product.product_code,
                          product.partial_qty_allocation
                            ? Number.parseFloat((selectedQuantity - 0.25).toFixed(3))
                            : selectedQuantity - 1,
                        )
                      }
                      className="text-gray-600 bg-gray-200 hover:bg-gray-300 rounded-full w-8 h-8 flex items-center justify-center"
                      disabled={!selectedProduct || selectedQuantity <= 0.001}
                    >
                      -
                    </button>
                    <input
                      type="number"
                      step={product.partial_qty_allocation ? "0.001" : "1"}
                      min="0.001"
                      value={selectedQuantity}
                      onChange={(e) => {
                        const newQuantity = Number.parseFloat(e.target.value) || 0
                        if (newQuantity > 0) handleQuantityChange(product.product_code, newQuantity)
                      }}
                      className="w-20 text-center border border-gray-300 rounded-md"
                    />
                    <button
                      onClick={() =>
                        handleQuantityChange(
                          product.product_code,
                          product.partial_qty_allocation
                            ? Number.parseFloat((selectedQuantity + 0.25).toFixed(3))
                            : selectedQuantity + 1,
                        )
                      }
                      className="text-gray-600 bg-gray-200 hover:bg-gray-300 rounded-full w-8 h-8 flex items-center justify-center"
                      disabled={!selectedProduct}
                    >
                      +
                    </button>
                    <span className="text-gray-700 font-semibold">{product.unit || "Unit"}</span>
                  </div>

                  <div className="text-sm text-gray-700 ml-4 text-right">
                    <p>
                      Price: <span className="font-semibold">LKR {price.toFixed(2)}</span>
                    </p>
                    <p>
                      Subtotal{" "}
                    </p>
                    <p>
                      <span className="font-semibold">LKR {(selectedProduct ? productTotal : 0).toFixed(2)}</span>
                    </p>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
        <div className="mt-6 space-y-4">
          <div>
            <label className="block text-gray-700 mb-2 text-sm sm:text-base">Pickup Location</label>
            <select
              className="border border-gray-300 rounded-md px-4 py-2 w-full text-sm sm:text-base"
              value={selectedLocation?.id || ""}
              onChange={(e) => {
                const selectedLocation = locations.find((loc) => loc.id === e.target.value)
                setSelectedLocation(selectedLocation || {}) // Ensure this contains valid data
              }}
            >
              <option value="" disabled>
                Select Location
              </option>
              {locations.map((location) => (
                <option key={location.id} value={location.id}>
                  {location.location_name}
                </option>
              ))}
            </select>
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 mb-2">Description</label>
              <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
                placeholder="Enter description here..."
                rows={4}
              />
              <p className="text-xs text-center font-semibold  text-red-600">
                (If your order request is successfully submitted, a confirmation WhatsApp message will be sent to your registered number.)
              </p>
        </div>
          <div className="flex justify-between items-center">
            <p className="text-lg font-semibold">Total Amount:</p>
            <p className="text-lg font-semibold text-right">LKR {totalPrice.toFixed(2)}</p>
          </div>
        </div>
        {!orderSubmitted && (
          <div className="mt-6 flex justify-end">
            <button
              onClick={handleConfirmOrder}
              className="bg-green-500 text-white px-6 py-2 rounded-md hover:bg-green-600"
            >
              Confirm Order
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default CustomerOrderRequest
